import React from 'react';
import { Button } from '@blueprintjs/core';
import { Classes, Popover2 } from '@blueprintjs/popover2';
import { getProjectName } from '../ma-helperfunctions/ma-helperfunctions';

const MaGuardarLivraria = ({ store, warning, setStoreStatus }) => {

  return (
    <Popover2
      popoverClassName={Classes.POPOVER2_CONTENT_SIZING}
      interactionKind='click'
      placement='bottom'
      content={
        <div className='popup-holder'>
          {warning ? (
            <p style={{ fontSize: '16px', lineHeight: '27px', textAlign: 'center' }}>
              O seu projeto não tem um nome
            </p>
          ) : (
            <p style={{ fontSize: '16px', lineHeight: '27px', textAlign: 'center' }}>
              O seu projeto será guardado na Biblioteca
            </p>
          )}
          {warning ? (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 15 }}>
              <Button
                          className={Classes.POPOVER2_DISMISS}
                          intent='primary'
                          text='Ok'
                          onClick={() => {                              
                              var input = document.getElementById('titleWorkName');
                              input.focus();
                          }}
              ></Button>
            </div>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 15 }}>
              <Button
                className={Classes.POPOVER2_DISMISS}
                text='Cancelar'
                outlined                
              >
              </Button>
              <Button
                className={Classes.POPOVER2_DISMISS}
                intent='primary'
                text='Confirmar'
                style={{ marginLeft: 10 }}
                onClick={async () => {

                  var fileName = getProjectName();

                  var url = '/api/livrarias/uploadDesigner';
                  var requestBody = {
                    Name: fileName + '.png',
                    Base64Image: store.toDataURL({ mimeType: 'image/png' }),
                    ContentType: 'imagem/png'
                  };

                  var xhr = new XMLHttpRequest();
                  xhr.open('POST', url, true);
                  xhr.setRequestHeader('Content-type', 'application/json');

                  xhr.onload = function () {

                    if (xhr.status !== 200) {
                      alert('Desculpe. Servidor indisponível.');
                    } else {

                      var res = JSON.parse(xhr.responseText);

                      var result = {
                        id: res.id,
                        imageIconLocation: res.imageIconLocation,
                        filename: res.displayName
                      };

                      //Notificar e enviar a info da imagem adicionada
                      window.parent.postMessage(result);

                    }
                  };

                  xhr.onerror = function () {
                    alert('Desculpe. Servidor indisponível.');
                  };

                  xhr.send(JSON.stringify(requestBody));
                  setStoreStatus(false);
                  setTimeout(() => {
                    setStoreStatus(true);
                  }, 1 * 60 * 1000);
                }}
              >
              </Button>
            </div>
          )}
        </div>
      }
    >

      <Button
        id='library-save'
        minimal
        text='Guardar na Biblioteca'
        icon='floppy-disk'
      />
    </Popover2>

  )
}

export default MaGuardarLivraria;